(() => {
  if (window.__awkProductFixes) return;
  window.__awkProductFixes = true;

  const stickySelector = '[data-awk-sticky-buy]';
  const reviewBadgeSelector = '.jdgm-preview-badge, .jdgm-prev-badge';

  function productIdFor(element) {
    if (!(element instanceof Element)) return '';
    const form = element.querySelector('product-form-component[data-product-id]');
    return form ? form.getAttribute('data-product-id') || '' : '';
  }

  function currentProductId() {
    const form = document.querySelector(
      '#MainContent [data-awk-standard-buybox] product-form-component[data-product-id], ' +
      '#MainContent .awk-ap product-form-component[data-product-id]'
    );
    return form ? form.getAttribute('data-product-id') || '' : '';
  }

  function removeSticky(bar) {
    if (!(bar instanceof HTMLElement)) return;
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    bar.remove();
  }

  function cleanStickyBars() {
    const bars = Array.from(document.querySelectorAll(stickySelector)).filter((bar) => bar instanceof HTMLElement);
    if (bars.length < 2) return;

    const currentId = currentProductId();
    const matching = currentId
      ? bars.filter((bar) => {
          const id = productIdFor(bar);
          return id === currentId || id === '';
        })
      : bars;

    let keep = matching.slice().reverse().find((bar) => bar.closest('#MainContent'));
    if (!keep) keep = matching[matching.length - 1] || bars[bars.length - 1];

    bars.forEach((bar) => {
      if (bar === keep) return;
      const isPortal = bar.parentElement === document.body && bar.getAttribute('data-awk-mobile-portal') === 'true';
      if (isPortal) removeSticky(bar);
    });
  }

  let cleanupQueued = false;
  function queueCleanup() {
    if (cleanupQueued) return;
    cleanupQueued = true;
    window.requestAnimationFrame(() => {
      cleanupQueued = false;
      cleanStickyBars();
    });
  }

  function fixBenefitRoles(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.awk-sp__benefits[role="list"]').forEach((list) => {
      list.removeAttribute('role');
      list.querySelectorAll('article[role="listitem"]').forEach((item) => item.removeAttribute('role'));
    });
  }

  function repairReference(element, attribute) {
    const value = element.getAttribute(attribute);
    if (!value) return;

    const ids = value.trim().split(' ').filter(Boolean);
    const valid = ids.filter((id) => document.getElementById(id));

    const repairedValue = valid.join(' ');
    if (repairedValue === value) return;

    if (repairedValue) element.setAttribute(attribute, repairedValue);
    else element.removeAttribute(attribute);
  }

  function fixJudgeMe(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.jdgm-widget [role="tab"], #judgeme_product_reviews [role="tab"]').forEach((tab) => {
      if (tab.id && tab.id.indexOf('jdgm-tab_') === 0) {
        const expectedPanelId = tab.id.replace('jdgm-tab_', 'jdgm-tabpanel_');
        if (document.getElementById(expectedPanelId)) {
          if (tab.getAttribute('aria-controls') !== expectedPanelId) {
            tab.setAttribute('aria-controls', expectedPanelId);
          }
        } else {
          repairReference(tab, 'aria-controls');
        }
      } else {
        repairReference(tab, 'aria-controls');
      }

      repairReference(tab, 'aria-labelledby');
      repairReference(tab, 'aria-describedby');

      const selected = tab.getAttribute('aria-selected');
      if (selected !== null && selected !== 'true' && selected !== 'false') {
        tab.setAttribute('aria-selected', 'false');
      }
    });
  }

  function alltagsRoot(root) {
    const scope = root && root.querySelector ? root : document;
    if (scope instanceof Element && scope.matches('.awk-ap')) return scope;
    return scope.querySelector('.awk-ap');
  }

  function replaceText(root, replacements) {
    if (!(root instanceof Element)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      let value = node.nodeValue || '';
      replacements.forEach(([from, to]) => {
        if (value.includes(from)) value = value.split(from).join(to);
      });
      node.nodeValue = value;
      node = walker.nextNode();
    }
  }

  function normalizeAlltagshelferCopy(root) {
    const page = alltagsRoot(root);
    if (!page) return;

    replaceText(page, [
      ['Gratis Versand für diesen Alltagshelfer', 'Gratis Versand nach Österreich & Deutschland'],
      ['Gratis Versand auf diesen Alltagshelfer', 'Gratis Versand nach Österreich & Deutschland'],
      ['Gratis Versand auf Alltagshelfer', 'Gratis Versand nach Österreich & Deutschland'],
      ['für unsere Alltagshelfer', 'nach Österreich & Deutschland'],
      ['auf unsere Alltagshelfer', 'nach Österreich & Deutschland']
    ]);
  }

  function makeReviewBadgeAccessible(root) {
    const page = alltagsRoot(root);
    if (!page) return;

    page.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
      if (!(badge instanceof HTMLElement)) return;
      const interactive = badge.querySelector('a[href], button, [role="button"], [role="link"], [tabindex]:not([tabindex="-1"])');
      if (interactive) return;
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label', 'Bewertungen ansehen');
    });
  }

  function reviewTarget() {
    const page = document.querySelector('#MainContent .awk-ap');
    if (!(page instanceof Element)) return null;
    return page.querySelector('#judgeme_product_reviews') || document.getElementById('judgeme_product_reviews');
  }

  function headerOffset() {
    const candidates = [
      document.querySelector('header-component'),
      document.getElementById('shopify-section-header'),
      document.querySelector('.shopify-section-group-header-group')
    ].filter((item) => item instanceof HTMLElement);

    return candidates.reduce((height, item) => Math.max(height, item.getBoundingClientRect().height), 0) + 18;
  }

  function scrollToReviews() {
    const target = reviewTarget();
    if (!(target instanceof Element)) return false;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerOffset());
    window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    return true;
  }

  function queueReviewScroll() {
    if (scrollToReviews()) return;
    [100, 250, 500, 900, 1500].forEach((delay) => window.setTimeout(scrollToReviews, delay));
  }

  function reviewBadgeFromEventTarget(target) {
    if (!(target instanceof Element)) return null;
    const badge = target.closest(reviewBadgeSelector);
    if (!(badge instanceof Element) || !badge.closest('#MainContent .awk-ap')) return null;
    return badge;
  }

  function handleReviewClick(event) {
    const badge = reviewBadgeFromEventTarget(event.target);
    if (!badge) return;
    event.preventDefault();
    queueReviewScroll();
  }

  function handleReviewKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const badge = reviewBadgeFromEventTarget(event.target);
    if (!(badge instanceof HTMLElement) || badge.getAttribute('role') !== 'link') return;
    event.preventDefault();
    queueReviewScroll();
  }

  function runFixes(root) {
    cleanStickyBars();
    fixBenefitRoles(root || document);
    fixJudgeMe(root || document);
    normalizeAlltagshelferCopy(root || document);
    makeReviewBadgeAccessible(root || document);
  }

  function initStickyObserver() {
    if (!(document.body instanceof HTMLBodyElement)) return;

    const observer = new MutationObserver((mutations) => {
      const stickyChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof Element &&
            (node.matches(stickySelector) || Boolean(node.querySelector(stickySelector)))
        )
      );

      if (stickyChanged) queueCleanup();
    });

    observer.observe(document.body, { childList: true });
  }

  function initJudgeMeObserver() {
    let widgetObserver = null;

    const attach = () => {
      const widget = document.getElementById('judgeme_product_reviews');
      if (!(widget instanceof Element)) return false;

      fixJudgeMe(widget);
      if (widgetObserver) return true;

      widgetObserver = new MutationObserver(() => fixJudgeMe(widget));
      widgetObserver.observe(widget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-selected']
      });

      window.setTimeout(() => {
        widgetObserver?.disconnect();
        widgetObserver = null;
      }, 15000);
      return true;
    };

    if (attach()) return;

    const discoveryObserver = new MutationObserver(() => {
      if (!attach()) return;
      discoveryObserver.disconnect();
    });

    if (document.body) {
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => discoveryObserver.disconnect(), 10000);
    }

    [300, 900, 1800, 3200, 6000].forEach((delay) => window.setTimeout(attach, delay));
  }

  function init() {
    runFixes(document);
    initStickyObserver();
    initJudgeMeObserver();

    document.addEventListener('click', handleReviewClick, true);
    document.addEventListener('keydown', handleReviewKeydown, true);

    [100, 400, 1000, 2500, 5000].forEach((delay) => {
      window.setTimeout(() => runFixes(document), delay);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    runFixes(event.target);
    window.setTimeout(queueCleanup, 50);
  });

  document.addEventListener('shopify:section:unload', queueCleanup);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) runFixes(document);
  });

  const scheduleInit = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(init, { timeout: 1800 });
    } else {
      window.setTimeout(init, 450);
    }
  };

  if (document.readyState === 'complete') {
    scheduleInit();
  } else {
    window.addEventListener('load', scheduleInit, { once: true });
  }
})();
